var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "class-select" }, [
    _c("ul", [
      _c(
        "li",
        {
          on: {
            click: function($event) {
              _vm.click("Y", _vm.$t("economy_cab"))
            }
          }
        },
        [_vm._v(_vm._s(_vm.$t("economy_cab")))]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          on: {
            click: function($event) {
              _vm.click("S", _vm.$t("super_cab"))
            }
          }
        },
        [_vm._v(_vm._s(_vm.$t("super_cab")))]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          on: {
            click: function($event) {
              _vm.click("C", _vm.$t("business_cab"))
            }
          }
        },
        [_vm._v(_vm._s(_vm.$t("business_cab")))]
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          on: {
            click: function($event) {
              _vm.click("F", _vm.$t("first_cab"))
            }
          }
        },
        [_vm._v(_vm._s(_vm.$t("first_cab")))]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-580d63b0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-580d63b0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/AirTicket/components/ClassSelect.vue
// module id = null
// module chunks = 